import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({ open, setOpen }) {
    const handleClose = () => {
        setOpen(false);

    };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    sx: { backgroundColor: 'rgb(217, 217, 217)' } // Đổi màu nền popup
                }}
            >
                <DialogTitle sx={{ fontWeight: 'bold' }}>Note on PIO to USDT swap</DialogTitle>
                <DialogContent dividers>
                    <DialogContentText id="alert-dialog-slide-description" sx={{ fontSize: '14px' }}>
                        <i>
                            The system is currently undergoing upgrades in preparation for the listing plan in June 2025. During this period, the PIO to USDT swap function may experience instability or temporary downtime.
                            We kindly ask for your understanding and encourage you to proceed with caution.
                        </i>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}><b>Got it</b></Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
